// extracted by mini-css-extract-plugin
export default {"btn":"TodoItem_btn__fM2uA","li":"TodoItem_li__C1YhH","finished":"TodoItem_finished__Gm7RA"};